import quickscan from '@/api/quickscan';
import cart from './cart';
import cartItem from './cartItem';
import cartItemSearch from './cartItemSearch';

const modules = {
    cart,
    cartItem,
    cartItemSearch,
};

const state = {
    searching: false,
    resultIds: null,
    error: null,
};

const getters = {
    results(state, getters, rootState) {
        if (state.resultIds === null)
            return null;
        return state.resultIds.map(id => rootState.data.amazonProducts.byId[id]);
    },
};

const actions = {
    clearAll({ commit }) {
        commit('CLEAR_ALL');
    },
    async search({ commit, dispatch, getters }, term) {
        if (!term)
            return;

        dispatch('clearCartItemSearchResults');
        commit('SEARCH_START');

        quickscan.searchWithFollowUps(term, getters.currentCart,
            (data) => dispatch('processResults', data),
            (data) => commit('data/UPDATE_AMAZONPRODUCT', data, { root: true })
        );
    },
    /*
     * Every path here has to reach one of the three terminal mutations.
     * SEARCH_START disables the search input until searching goes false, so a
     * response that commits nothing does not merely leave a spinner running,
     * it locks the page until a reload.
     *
     * A scan that finds nothing is the ordinary case now rather than an edge
     * one: keyword lookup was MWS ListMatchingProducts, so a term matching no
     * local product returns an empty list with no error. That is the response
     * that used to fall through both branches below.
     */
    processResults({ commit }, { amazonProducts, error }) {
        if (error) {
            commit('SEARCH_ERROR', { error });

            return;
        }

        if (amazonProducts?.length > 0) {
            commit('data/LOAD_ENTITIES', { amazonProducts }, { root: true });
            commit('SEARCH_FINISH', { amazonProducts });

            return;
        }

        commit('SEARCH_FINISH_EMPTY');
    },
};

const mutations = {
    CLEAR_ALL(state) {
        state.searching = false;
        state.resultIds = null;
        state.error = null;
    },
    SEARCH_START(state) {
        state.searching = true;
        state.resultIds = null;
        state.error = null;
    },
    SEARCH_FINISH(state, { amazonProducts }) {
        state.searching = false;
        state.resultIds = amazonProducts.map(amazonProduct => amazonProduct.id);
        state.error = null;
    },
    /*
     * resultIds is only filled in when nothing is on screen yet, so an empty
     * follow up response does not wipe results the first response already
     * rendered. searchWithFollowUps calls back twice whenever needsRefresh is
     * set, and not clobbering the first set of results is what the MWS era
     * band-aid was protecting when it stopped committing SEARCH_FINISH for an
     * empty list. It is still worth protecting; leaving the search running
     * forever was the cost of doing it by committing nothing at all.
     *
     * null means no search has run, an empty array means a search found
     * nothing, and the template tells the two apart: `results && !results.length`
     * is what renders "No results".
     */
    SEARCH_FINISH_EMPTY(state) {
        state.searching = false;
        state.error = null;

        if (state.resultIds === null) {
            state.resultIds = [];
        }
    },
    SEARCH_ERROR(state, { error }) {
        state.searching = false;
        // state.resultIds = null;
        state.error = error;
    },
};

export default {
    modules,
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
};
